import { ClarityType } from '../clarityValue';
const noneCV = () => ({ type: ClarityType.OptionalNone });
const someCV = (value) => ({ type: ClarityType.OptionalSome, value });
const optionalCVOf = (value) => {
    if (value) {
        return someCV(value);
    }
    else {
        return noneCV();
    }
};
export { noneCV, someCV, optionalCVOf };
//# sourceMappingURL=optionalCV.js.map